import styled from 'styled-components';
import Column from '@sdk/components/ui/spacing/Column';
import ModalBodyContainer from '@sdk/components/ui/modal/ModalBodyContainer';

export const ModalContainer = styled(Column)`
  height: 280px;
  width: 440px;
  padding: 0 20px;
  text-align: center;
  border-radius: 8px;
  cursor: pointer;
  background: ${({ theme }) => theme.colors.white};
`;

export const ConfirmationStateWrapper = styled.div`
  ${ModalBodyContainer} {
    border-radius: 8px;
  }
`;
